import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, pimsService } from '@v2/services';
import type { UpdatePimsAppRelationPayload } from '@v2/types';

interface UseUpdatePimsAppRelationResult {
  updateAppRelation: (payload: UpdatePimsAppRelationPayload) => Promise<void>;
  loading: boolean;
  error: string | null;
}

export const useUpdatePimsAppRelation = (): UseUpdatePimsAppRelationResult => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: pimsService.updateAppRelation,
    onSuccess: (_data, payload) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.pims.detail(payload.id) });
      queryClient.invalidateQueries({ queryKey: queryKeys.pims.lists() });
    },
  });

  return {
    updateAppRelation: mutation.mutateAsync,
    loading: mutation.isPending,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
};

export default useUpdatePimsAppRelation;
